// extracted by mini-css-extract-plugin
export default {"detailsContainer":"contact-details_detailsContainer__RjLGJ","detailItem":"contact-details_detailItem__CfzvU","flexRow":"contact-details_flexRow__l4wDw"};